import {StyleSheet} from 'react-native';

import {disabledTextColor} from '/component/base/TextInput/TextInput.style';
import {indent} from '/constant/layout.constant';
import {
  boulder,
  denim,
  grayscale,
  lightGray,
  onyxLighter,
} from '/theme/color/on.color';
import {chestnut, codGray} from '/theme/color/secondary.color';
import {getInputFontFamily} from '/util/text.util';

const textIndent = 2;

export const styles = StyleSheet.create({
  base: {},
  contentRow: {
    flexDirection: 'row',
  },
  iconColumn: {
    flex: 0,
  },
  contentColumn: {
    flex: 1,
  },
  icon: {
    width: 24,
    height: 24,
    marginTop: 2,
    marginRight: 8,
    fontSize: 24,
    color: grayscale,
  },
  iconError: {
    color: chestnut,
  },
  label: {
    marginTop: 4,
    marginBottom: 4,
    paddingLeft: textIndent * 15,
    color: codGray,
  },
  labelDisabled: {
    color: disabledTextColor,
  },
  textInputWithShowButton: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
  },
  biometricContainer: {
    position: 'absolute',
    right: 10,
  },
  textInput: {
    ...getInputFontFamily(),
    paddingLeft: textIndent,
    flex: 1,
    color: codGray,
  },
  textInputLogin: {
    ...getInputFontFamily(),
    flex: 1,
    color: codGray,
    backgroundColor: lightGray,
    borderWidth: 1,
    height: 48,
    borderRadius: 6,
    marginTop: 8,
    paddingHorizontal: 16,
    paddingVertical: 8,
  },
  itemIcon: {
    fontSize: 30,
    color: denim,
    marginTop: 8,
  },
  biometricAndPinContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: indent,
  },
  showButton: {
    textAlignVertical: 'center',
    color: codGray,
    paddingVertical: 4,
    paddingHorizontal: 4,
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
  },
  labelContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  showHideButtonContainer: {
    flexDirection: 'row',
  },
  showHideIcon: {
    width: 24,
    height: 24,
    marginRight: 4,
    marginTop: 2,
    color: denim,
  },
  divider: {
    marginTop: 10,
    height: 1,
    backgroundColor: grayscale,
  },
  dividerError: {
    backgroundColor: chestnut,
  },
  assistiveText: {
    marginTop: 6,
    paddingLeft: textIndent,
    color: onyxLighter,
  },
  assistiveTextDisabled: {
    color: disabledTextColor,
  },
  assistiveTextError: {
    color: chestnut,
  },
  clearIcon: {
    fontSize: 18,
    color: boulder,
  },
});
